import React from 'react';

import { useStripeCreateSetupIntentMutation } from 'src/api';
import { StripeAddPaymentMethodForm, StripeElements } from 'src/components/stripe';
import { useModal } from 'src/hooks/shared';

export interface VerifierStaffAddPaymentMethodModalContentProps {
  onCloseModal: () => void;
  switchClosability: ReturnType<typeof useModal>['switchClosability'];
  returnUrl: string;
}

export const VerifierStaffAddPaymentMethodModalContent: React.FC<
  VerifierStaffAddPaymentMethodModalContentProps
> = ({ switchClosability, onCloseModal, returnUrl }) => {
  const [clientSecret, setClientSecret] = React.useState<string | null>(null);

  const [createSetupIntent, { loading: isSetupIntentLoading }] =
    useStripeCreateSetupIntentMutation();

  React.useEffect(() => {
    const fetchClientSecret = async () => {
      const response = await createSetupIntent();
      if (response.data?.stripeCreateSetupIntent) {
        setClientSecret(response.data.stripeCreateSetupIntent.clientSecret);
      }
    };

    if (!clientSecret && !isSetupIntentLoading) {
      fetchClientSecret();
    }
  }, [clientSecret, createSetupIntent, isSetupIntentLoading]);

  return (
    <StripeElements clientSecret={clientSecret} isClientSecretLoading={isSetupIntentLoading}>
      <StripeAddPaymentMethodForm
        returnUrl={returnUrl}
        onCancel={onCloseModal}
        switchClosability={switchClosability}
      />
    </StripeElements>
  );
};
